import { useHistory } from 'react-router-dom'
import { useModal } from '@ebay/nice-modal-react'

import SubMenuBtn from '../SubMenuBtn'

import s from './IdeaLabMenu.module.css'

type Props = {
  onClose: () => void
  projectId?: string
}

const IdeaLabMenu = ({ onClose, projectId }: Props) => {
  const history = useHistory()
  const { show: showProjectSelector } = useModal('select-project-modal')

  const handleDiscover = (tab: 'topics' | 'keywords') => {
    if (projectId) {
      history.push(`/project/${projectId}/${tab}?content_ideas=1`)
    } else {
      showProjectSelector({
        onAfterSelectId: (_projectId: string, isDomainConnected: boolean) => {
          let url = `/project/${_projectId}/${tab}?content_ideas=1`
          if (!isDomainConnected) {
            url += '&link_domain=1'
          }
          history.push(url)
        },
      })
    }
    onClose()
  }

  const handleImport = (tab: 'topics' | 'keywords') => {
    if (projectId) {
      history.push(`/project/${projectId}/${tab}?isImportModalOpen=1`)
    } else {
      showProjectSelector({
        onAfterSelectId: (_projectId: string, isDomainConnected: boolean) => {
          let url = `/project/${_projectId}/${tab}?isImportModalOpen=1`
          if (!isDomainConnected) {
            url += '&link_domain=1'
          }
          history.push(url)
        },
      })
    }
    onClose()
  }

  return (
    <div className={s.wrapper}>
      <div className={s.section}>
        <span className={s.title}>Topics</span>
        <SubMenuBtn onClick={() => handleDiscover('topics')}>
          Discover Topics
        </SubMenuBtn>
        <SubMenuBtn onClick={() => handleImport('topics')}>
          Import Topics
        </SubMenuBtn>
      </div>
      <div className={s.section}>
        <span className={s.title}>Keywords</span>
        <SubMenuBtn onClick={() => handleDiscover('keywords')}>
          Discover Keywords
        </SubMenuBtn>
        <SubMenuBtn onClick={() => handleImport('keywords')}>
          Import Keywords
        </SubMenuBtn>
      </div>
    </div>
  )
}

export default IdeaLabMenu
